// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createBtn[data-v-002f8c8c]{width:80px;margin-left:20px;background-color:#0092ff}", ""]);
// Exports
module.exports = exports;
